import { Epic, ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../../actions';
import {
    DUPLICATE_INTERNAL_BANNER,
    DuplicateInternalBanner
} from '../../../actions/bannersEdit/internal/duplicateInternalBanner';
import { scrollToElementById } from '../../../service/ScrollHelpers';
import { EpicDeps } from '../../../service/StoreFactory';
import { State } from '../../../typings/state';

export const scrollToDuplicateInternalBannerEpic: Epic<Action, Action, State, EpicDeps> = action$ => {
    return action$.pipe(
        ofType(DUPLICATE_INTERNAL_BANNER),
        mergeMap((action: DuplicateInternalBanner) => {
            scrollToElementById(action.newBannerId);

            return EMPTY;
        })
    );
};
